import Auth0Provider from 'components/Auth/Auth0Provider';
import {
  useAuth0 as useOfficialAuth0,
  withAuthenticationRequired as withOfficialAuthenticationRequired,
} from '@auth0/auth0-react';

import withMockAuthenticationRequired from './mock/with-mock-authentication-required';
import { MockAuth0Context } from './mock/MockAuth0Provider';

export function useAuth0(): ReturnType<typeof useOfficialAuth0> {
  return useOfficialAuth0(
    window['__useMockSSO'] ? MockAuth0Context : undefined
  );
}

const withAuthenticationRequired = (...args) => {
  // @ts-ignore
  if (window.__useMockSSO === true) {
    // @ts-ignore
    return withMockAuthenticationRequired(...args);
  } else {
    // @ts-ignore
    return withOfficialAuthenticationRequired(...args);
  }
};

export { Auth0Provider, withAuthenticationRequired };
